var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkBrokenStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "47px",
    viewBox: "0 0 22 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "link-broken") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uq-binders",
    transform: "translate(-1167.000000, -230.000000)",
    fill: "#9DB913",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(399.000000, 202.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "link-broken",
    transform: "translate(768.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.84375,32.8125 L9.75,32.8125 C4.36522369,32.8125 0,28.4472763 0,23.0625 C0,17.6777237 4.36522369,13.3125 9.75,13.3125 L15.84375,13.3125 C16.516847,13.3125 17.0625,13.858153 17.0625,14.53125 C17.0625,15.204347 16.516847,15.75 15.84375,15.75 L9.75,15.75 C5.71141777,15.75 2.4375,19.0239178 2.4375,23.0625 C2.4375,27.1010822 5.71141777,30.375 9.75,30.375 L15.84375,30.375 C16.516847,30.375 17.0625,30.920653 17.0625,31.59375 C17.0625,32.266847 16.516847,32.8125 15.84375,32.8125 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,46.125 C19.3873091,46.125 18.890625,45.7562345 18.890625,45.3013393 L18.890625,0.823660714 C18.890625,0.368765463 19.3873091,0 20,0 C20.6126909,0 21.109375,0.368765463 21.109375,0.823660714 L21.109375,45.3013393 C21.109375,45.7562345 20.6126909,46.125 20,46.125 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.671875,21.84375 L11.578125,21.84375 C10.905028,21.84375 10.359375,22.389403 10.359375,23.0625 C10.359375,23.735597 10.905028,24.28125 11.578125,24.28125 L17.671875,24.28125 L17.671875,21.84375 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkBrokenStart);
export default __webpack_public_path__ + "static/media/link-broken-start.4031d6980cf60d1adece8e2dd804f656.svg";
export { ForwardRef as ReactComponent };